import { z } from "zod";

export const BankAccountSchema = z.object({
    id: z.number(),
    status: z.number(),
    applicant_id: z.number(),
    address: z.string(),
    address_2: z.string().nullable(),
    city: z.string(),
    zip_code: z.string(),
    global_state_id: z.number(),
    account_number: z.string(),
    routing_number: z.string(),
    bank_name: z.string(),
    account_holder_name: z.string(),
    account_holder_dob: z.string(),
    account_nickname: z.string(),
    account_type_id: z.number(),
    verification_status_id: z.number(),
    created_at: z.string(),
    updated_at: z.string()
  });
  


export const BankAccountResponseSchema = z.union([BankAccountSchema, z.object({})])